import enums from './enums'
import ReactPixel from 'react-facebook-pixel'

ReactPixel.init('424542114704151', {}, { debug: true, autoConfig: false })

export const track = (area, key, type = 'add_event') => {
  const eventData = enums[area][key]
  if (!eventData) {
    return
  }
  const countlyKey = eventData['key'],
    countlySegement = eventData['segmentation']

  Countly.q.push([
    type, {
      key: countlyKey,
      count: 1,
      segmentation: countlySegement
    }
  ])
}

export const trackCustom = (key, segment, type = 'add_event') => {
  Countly.q.push([
    type, {
      key: key,
      count: 1,
      segmentation: segment
    }
  ])
}

export const trackOnFacebook = (event, data) => {
  ReactPixel.trackCustom(event, data)
}

const trackClick = (component, name) => {
  const segment = { 'Click': enums[component].segments[name] },
    key = enums[component]
  track(key, segment)
}

